import React, { Component } from 'react';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card ,Button } from 'reactstrap';
import { getFilterType } from "./util";
import { COMPARATIVE_PAYMENT_BEHAVIOUR, COMPARATIVE_PAYMENT_BEHAVIOUR_DESCRIPTION } from '../constants';

class ComparativePaymentBehaviourChartComponent extends Component {

  state = {
    barChartProperties: { with_me_color: '', with_cug_member: '', cug_group_color: '' },
    selectedTypefilter: "Overall", selectedMonthFilter : undefined, filteredData : []
  }

  componentDidMount() {
    if (this.props.chartData) {
      this.setState({ chartData: this.props.chartData })
    } else {
    }


  }

  componentDidUpdate(prevProps){
    if(prevProps.chartData !== this.props.chartData){
      this.setState({ selectedMonthFilter :this.props.monthfilters[0] }, ()=>{
        this.filterData();
      })
    }
  }


  filterData = () => {
    let type = getFilterType(this.state.selectedTypefilter);
    let filteredData = this.props.chartData.filter(element => element.type == type && element.month == this.state.selectedMonthFilter);
    this.setState({ filteredData :filteredData })
  }

  handleTypeFilter = (e) => {
    if (this.state.selectedTypefilter !== e.target.value) {
      this.setState({ selectedTypefilter: e.target.value }, ()=>{
        this.filterData();
      })
    }
    e.preventDefault();
  }

  handleMonthFilter = (e) => {
    if (this.state.selectedMonthFilter !== e.target.value) {
      this.setState({ selectedMonthFilter: e.target.value }, ()=>{
        this.filterData();
      })
    }
    e.preventDefault();
  }

  render() {
    return (
       
            <Card body className='mt-3' >
              <div>
                <h3 className='text-center'>
                  {COMPARATIVE_PAYMENT_BEHAVIOUR}
                </h3>

                {
                  this.props.typeFilters 
                  && this.props.typeFilters.length > 0 
                  && <select className='position-absolute chart-filter-dropdown' name="typefilter" onChange={(e) => this.handleTypeFilter(e)}  value={this.state.selectedTypefilter}>
                      {this.props.typeFilters.map(optionValue => (<option value={optionValue} key={Math.random()}  >{optionValue}</option>))}
                    </select>
                }
              </div>
              <div>              {
                  this.props.monthfilters 
                  && this.props.monthfilters.length > 0 
                  && <select className='float-right' style={{marginRight : "2rem", paddingLeft :"1rem", paddingRight:"1rem", height:"36px", borderRadius:"7.5px", width :"175px"}} name="monthfilter" onChange={(e) => this.handleMonthFilter(e)} value ={this.state.selectedMonthFilter}>
                    {this.props.monthfilters.map((optionValue, index) => (<option key={index} value={optionValue} >{optionValue}</option>))}
                  </select>
                }
                </div>
              <ResponsiveContainer width='100%' height={300}>
                <BarChart
                  data={this.state.filteredData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}  >

                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend style={{ marginTop: `5px !important` }} />
                  <Bar dataKey="beforeDueDate" fill="#00b050" name='Before Due Date' stackId='a' />
                  <Bar dataKey="_0_30_days" fill="#92d050" name='0-30 days' stackId='a' />
                  <Bar dataKey="_31_60_days" fill="#ffff00" name='31-60 days' stackId='a' />
                  <Bar dataKey="_61_90_days" fill="#ffc000" name='61-90 days' stackId='a' />
                  <Bar dataKey="_91_120_days" fill="#fd5f76" name='91-120 days' stackId='a' />
                  <Bar dataKey="_121_180_days" fill="#f83644" name='121-180 days' stackId='a' />
                  <Bar dataKey="_180_plus_days" fill="#ff0000" name='180 + days' stackId='a' />
                </BarChart>
              </ResponsiveContainer>
          
              <details>
                    <summary>
                        <i>Know more...</i>
                    </summary>
                    <p dangerouslySetInnerHTML={{ __html: COMPARATIVE_PAYMENT_BEHAVIOUR_DESCRIPTION }}></p>
                </details>
            </Card>
    );
  }
}

export default ComparativePaymentBehaviourChartComponent;